/**
 * Check if we need to setup PR stuff,
 * do it if we do.
 */
export const setupPowerReviews = () => {
	const variationsForm = document.querySelector(
		'form.variations_form.cart'
	);
	if ( variationsForm ) {
		window.pwr =
			window.pwr ||
			function () {
				( pwr.q = pwr.q || [] ).push( arguments );
			};
		if (
			'undefined' === typeof window.POWER_REVIEWS_JSON ||
			window.POWER_REVIEWS_JSON.unique_variant_reviews
		) {
			return;
		}
		watchProductVariantDropdowns( variationsForm );
	}
};

/**
 * Watch variation dropdowns for change and
 * update PR components for new variant.
 */
const watchProductVariantDropdowns = ( form ) => {
	const variations = JSON.parse( form.dataset.product_variations );
	const selectInputs = form.querySelectorAll( 'select[data-attribute_name]' );
	selectInputs.forEach( ( input ) => {
		input.onchange = ( { target } ) =>
			rerenderPowerReviewsComponents(
				target.dataset.attribute_name,
				target.value,
				variations
			);
	} );
};

/**
 * Clear existing PR components and rerender for updated variant
 * @param string attribute
 * @param string value
 * @param array variations
 */
const rerenderPowerReviewsComponents = ( attribute, value, variations ) => {
	const newVariant = getNewVariant( attribute, value, variations );
	if ( newVariant ) {
		unmountExistingPowerReviewsComponents();
		updatePowerReviewsData( newVariant );
		pwr( 'render', window.POWER_REVIEWS_JSON );
	} else {
		// error here
		console.error( 'Could not find variant for:', attribute, value );
	}
};

/**
 * Find the new variant from our list of variants
 */
const getNewVariant = ( attribute, value, variations ) => {
	const currentVariant = variations.find(
		( variant, index ) =>
			variant.variation_id === window.POWER_REVIEWS_JSON.page_id
	);

	const attributes = { ...currentVariant.attributes };
	attributes[ attribute ] = value;

	const attributeKeys = Object.keys( { ...currentVariant.attributes } );

	return variations.find( ( variant ) => {
		let match = true;
		for ( let i = 0; i < attributeKeys.length; i++ ) {
			if (
				variant.attributes[ attributeKeys[ i ] ] !==
				attributes[ attributeKeys[ i ] ]
			) {
				match = false;
			}
		}
		return match;
	} );
};

const unmountExistingPowerReviewsComponents = () => {
	const components = Object.values( window.POWER_REVIEWS_JSON.components );
	components.forEach( ( component ) => {
		const el = document.getElementById( component );
		pwr( 'unmount', component );
	} );
};

/**
 * Update the `POWER_REVIEWS_JSON` object with
 * new variation data.
 * @debug `newVariant` is wrong
 */
const updatePowerReviewsData = ( newVariant ) => {
	const variantMeta = window.POWER_REVIEWS_JSON.product._variants.find(
		( variant ) => variant.page_id_variant === newVariant.variation_id
	);
	window.POWER_REVIEWS_JSON.page_id = newVariant.variation_id;
	updatePowerReviewsProductData( newVariant, variantMeta );
	updatePowerReviewsSubjectData( newVariant, variantMeta );
};

const updatePowerReviewsProductData = ( variant, meta ) => {
	const { sku, is_in_stock } = variant;
	const { name, url, image_url } = meta;
	window.POWER_REVIEWS_JSON.product = {
		...window.POWER_REVIEWS_JSON.product,
		name,
		url,
		image_url,
		in_stock: is_in_stock,
		upc: sku,
	};
};

const updatePowerReviewsSubjectData = ( variant, meta ) => {
	const { sku, is_in_stock, display_price } = variant;
	const { name, url, image_url } = meta;
	window.POWER_REVIEWS_JSON.subject = {
		...window.POWER_REVIEWS_JSON.subject,
		name,
		url,
		image: image_url,
		sku: sku,
	};
	window.POWER_REVIEWS_JSON.subject.offers = {
		...window.POWER_REVIEWS_JSON.subject.offers,
		url,
		price: display_price,
		availability: `https://schema.org/${
			is_in_stock ? 'InStock' : 'OutOfStock'
		}`,
	};
};
